export default __webpack_public_path__ + "static/caramel-banner-mobile-8bc0af799f1da439355af0b89172255d.webp";